import React from 'react';
import PropTypes from 'prop-types';

export default class Breadcrumbs extends React.Component {
  static propTypes = {
    // The heading element the trail renders in; defaults to an h6.
    as: PropTypes.elementType,
    folders: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      id: PropTypes.number,
    })),
    onNavigation: PropTypes.func.isRequired
  }

  render() {
    const Heading = this.props.as || 'h6';
    const folders = this.props.folders.map((folder, i) => {
      return (
        <span className="clickable" key={i} onClick={() => this.props.onNavigation(folder)}>
          {folder.name}
          {i < this.props.folders.length - 1 && (
            <span className="mx-2">{'>'}</span>
          )}
        </span>
      );
    });

    return (
      <Heading>
        {folders}
      </Heading>
    );
  }
}
